var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7499 9.5H17.6249C18.1222 9.5 18.5991 9.69754 18.9508 10.0492C19.3024 10.4008 19.4999 10.8777 19.4999 11.375V20.375C19.4999 20.8723 19.3024 21.3492 18.9508 21.7008C18.5991 22.0524 18.1222 22.25 17.6249 22.25H6.37494C5.87766 22.25 5.40074 22.0524 5.04911 21.7008C4.69748 21.3492 4.49994 20.8723 4.49994 20.375V11.375C4.49994 10.8777 4.69748 10.4008 5.04911 10.0492C5.40074 9.69754 5.87766 9.5 6.37494 9.5H8.24994",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7499 6.49804L11.9999 2.74805L8.24994 6.49804",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 15.5449V2.74805",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareOutline);
export default __webpack_public_path__ + "static/media/share-outline.9cd691bcf8ac2402f2d1586d8667d6a0.svg";
export { ForwardRef as ReactComponent };